// extracted by mini-css-extract-plugin
module.exports = {"noMarginTop":"_2W2aR"};